import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import Logo from "../public-routes-images/logos/Manga Cons Logo.png";
import IsLoading from "../../../isLoading";
import "./regFormPrinting.css";
let continueationData;

export default function RegFormPrinting() {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  function printing() {
    window.print();
  }

  const fetchData = async () => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_application/completed/printing/${id}`
      )
      .then((response) => {
        continueationData = response.data.response;
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="section_regFormPrint fx-cl">
      {loading ? <IsLoading /> : null}
      <header className="fx-cl fx-ac spacem">
        <figure className="formprintPassport">
          <img src={continueationData?.passport.url} alt="passport" />
        </figure>
        <figure className="formprintlogo">
          <img src={Logo} alt="mangacons logo" />
        </figure>
        <h2>MANGA COLLEGE OF NURSING SCIENCES, ZURU</h2>
        <p>No. 2 Zuru Kontagora road, Amanawa Area, Zuru, Kebbi State</p>
        <p>(OFFICE OF THE REGISTRAR)</p>
      </header>
      <section className="sectionPrint">
        <div className="fx-cl">
          <div className="fx-ac ">
            <div
              className="printingMode fx-cl spacem"
              style={{ width: "100%" }}
            >
              <div className=" fx-ac space2">
                <div className="contentsAd fx-cl spacem">
                  <h2>Personal information</h2>
                </div>
              </div>
              <div className="g g2 space2">
                <div className="fx-cl spacem">
                  <h3>First name</h3>
                  <span>{continueationData?.first_Name}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Last name:</h3>
                  <span>
                    {continueationData?.sur_Name +
                      " " +
                      continueationData?.other_Name}
                  </span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Email</h3>
                  <span>{continueationData?.email}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Phone number</h3>
                  <span>{continueationData?.phone_number}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Application Number: </h3>
                  <span>{id}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Programme of study</h3>
                  <span>{continueationData?.programme_of_study}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="printingMode fx-cl spacem">
            <div className=" fx-ac space3">
              <div className="contentsAd fx-cl spacem">
                <h2>Address</h2>
              </div>
            </div>
            <div className="g g2 space2">
              <div className="fx-cl spacem">
                <h3>Nationality</h3>
                <span>{continueationData?.Nationality}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>State of origin</h3>
                <span>{continueationData?.State_of_origin}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Local Gov't Area</h3>
                <span>{continueationData?.Local_Govt_Area}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Address</h3>
                <span>{continueationData?.Residential_address}</span>
              </div>
            </div>
          </div>
          <div className="printingMode fx-cl spacem">
            <div className=" fx-ac space3">
              <div className="contentsAd fx-cl spacem">
                <h2>Educational Record</h2>
              </div>
            </div>
            <div className="g g4 space2">
              <div className="fx-cl spacem">
                <h3>Primary school</h3>
                <span>
                  {
                    continueationData?.eductional_records.primary_school
                      .institution_name
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Year started</h3>
                <span>
                  {
                    continueationData?.eductional_records.primary_school
                      .year_started
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Year of Grad</h3>
                <span>
                  {
                    continueationData?.eductional_records.primary_school
                      .year_finish
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Certificate obtained</h3>
                <span>
                  {
                    continueationData?.eductional_records.primary_school
                      .certficate_obtained
                  }
                </span>
              </div>
            </div>
            <div className="g g4 space2">
              <div className="fx-cl spacem">
                <h3>Junior Secondary school</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .junior_secondary_school.institution_name
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Year started</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .junior_secondary_school.year_started
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Year of Grad</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .junior_secondary_school.year_finish
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Certificate obtained</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .junior_secondary_school.certficate_obtained
                  }
                </span>
              </div>
            </div>
            <div className="g g4 space2">
              <div className="fx-cl spacem">
                <h3>Senior Secondary school</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .senior_secondary_school.institution_name
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Year started</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .senior_secondary_school.year_started
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Year of Grad</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .senior_secondary_school.year_finish
                  }
                </span>
              </div>
              <div className="fx-cl spacem">
                <h3>Certificate obtained</h3>
                <span>
                  {
                    continueationData?.eductional_records
                      .senior_secondary_school.certficate_obtained
                  }
                </span>
              </div>
            </div>
          </div>

          {/* <div className="printingMode fx-cl space2">
            <div className=" fx-ac space3">
              <div className="contentsAd fx-cl spacem">
                <h2>REFEREES</h2>
              </div>
            </div>
            <div className="g g4 space2">
              <div className="fx-cl spacem">
                <h3>Referee Full Name</h3>
                <span>{continueationData?.firstRef_name}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Address</h3>
                <span>{continueationData?.firstRef_address}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Email</h3>
                <span>{continueationData?.firstRef_email}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Phone Number</h3>
                <span>{continueationData?.firstRef_phone}</span>
              </div>
            </div>
            <div className="g g4 space2">
              <div className="fx-cl spacem">
                <h3>Referee Full Name</h3>
                <span>{continueationData?.secondRef_name}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Address</h3>
                <span>{continueationData?.secondRef_address}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Email</h3>
                <span>{continueationData?.secondRef_email}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Phone Number</h3>
                <span>{continueationData?.secondRef_phone}</span>
              </div>
            </div>
            <div className="g g4 space2">
              <div className="fx-cl spacem">
                <h3>Referee Full Name</h3>
                <span>{continueationData?.nok_name}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Address</h3>
                <span>{continueationData?.nok_address}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Relationship</h3>
                <span>{continueationData?.nok_relationship}</span>
              </div>
              <div className="fx-cl spacem">
                <h3>Phone Number</h3>
                <span>{continueationData?.nok_phone}</span>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      <div className="fx-jb space3">
        <span>&nbsp;</span>

        <button
          style={{
            backgroundColor: "#64f727",
            padding: "1.2rem 3.2rem",
            color: "fff",
            marginBottom: "4.3rem",
          }}
          onClick={() => printing()}
        >
          Print form
        </button>
      </div>
    </div>
  );
}
